import { render, staticRenderFns } from "./cookies-blocked-alert.vue?vue&type=template&id=154797f1"
import script from "./cookies-blocked-alert.ts?vue&type=script&lang=ts&external"
export * from "./cookies-blocked-alert.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
